import EditParameterAlertModal from './containers/EditParameterAlertModalContainer'

export default EditParameterAlertModal
